export const ENDPOINTS = {
    auth: {
        session: "/auth/session",
    },
    workspace: {
        fetch: "/workspaces",
        patientForm: "/workspaces/patient-form",
    },
    appointments: {
        availableSlots: "/appointments/available-slots",
        followUpEligibility: (doctorId) => `/appointments/doctors/${doctorId}/follow-up-eligibility`,
        bookLegacy: "/appointments/book-appointment",
        bookUnified: "/appointments/book-appointment-unified",
        reserveSlot: "/appointments/reserve-slot",
        confirmPayment: "/appointments/confirm-payments",
        update: "/appointments/update-appointment",
        reschedule: (id) => `/appointments/${id}/reschedule`,
        delete: (id) => `/appointments/${id}/delete`,
        listWithDetails: "/appointments/list-with-details",
    },
    qms: {
        doctorShifts: "/qms-appointments/doctor/shifts",
        bookImmediate: "/qms-appointments/immediate/book",
        bookPre: "/qms-appointments/pre/book",
    },
    otp: {
        send: "/otp/send",
        verify: "/otp/verify",
    },
    patients: {
        sendPhoneVerificationOtp: "/patients/send-phone-verification-otp",
        verifyPhoneVerificationOtp: "/patients/verify-phone-verification-otp",
        searchByPhone: "/patients/search-by-phone",
    },
    publicProfiles: {
        byId: (profileId) => `/public-profiles/${profileId}`,
    },
    meetings: {
        create: "/meeting/create",
        end: (id) => `/meeting/${id}/end-meeting`,
    },
    inbox: {
        create: "/inbox/create",
    },
    payments: {
        methods: "/workspaces/payment-methods",
        claim: (appointmentId) => `/appointments/${appointmentId}/payment-claim`,
        claimProof: (appointmentId) => `/appointments/${appointmentId}/payment-claim/proof`,
    },
    portal: {
        myAppointments: "/appointments/mine",
        createPatient: "/patients",
        sessionPacks: "/patients/session-packs",
        appointmentStatus: (id) => `/appointments/${id}/status`,
        cancelAppointment: (id) => `/appointments/${id}/cancel`,
    },
};
